// React
import { memo, useCallback } from "react";

// UI
import { DatePicker } from "ui/components/DatePicker";
import { TextField } from "ui/components/TextField/TextField";

// Lokalne komponente
import PricingStepIntro from "ui/modules/pricing/components/PricingStepIntro/PricingStepIntro";

// Tipovi
import { OverrideStepProps } from "../../types";

const toIsoDate = (date: Date): string => date.toISOString().slice(0, 10);

/** Zašto se uvjet daje i dokad vrijedi. Oboje je obavezno. */
const OverrideTermsStep: React.FC<OverrideStepProps> = (props: OverrideStepProps) => {
  const { formValues, setFormValues, errors } = props;

  const handleReasonChange = useCallback(
    (e: any) => {
      const value = e?.target?.value ?? null;

      setFormValues((previous) => ({ ...previous, reason: value }));
    },
    [setFormValues]
  );

  const handleValidFromChange = useCallback(
    (_name: string, date: Date | null) => {
      setFormValues((previous) => ({ ...previous, validFrom: date ? toIsoDate(date) : null }));
    },
    [setFormValues]
  );

  const handleValidToChange = useCallback(
    (_name: string, date: Date | null) => {
      setFormValues((previous) => ({ ...previous, validTo: date ? toIsoDate(date) : null }));
    },
    [setFormValues]
  );

  return (
    <>
      <PricingStepIntro
        title="Rok i razlog"
        description={
          <>
            Rok je obavezan. Po isteku klijent pada natrag u svoju grupu, uz zapis u povijesti,
            pa uvjet ne ostaje zauvijek zato što ga je netko zaboravio.
          </>
        }
      />

      <div className="flex flex-col gap-4 p-4 w-full max-w-4xl mx-auto">
        <div>
          <TextField
            type="text"
            name="reason"
            label="Razlog"
            placeholder="Zašto se uvjet daje"
            value={formValues.reason ?? ""}
            onChange={handleReasonChange}
            error={errors.reason}
            required
            width="full"
          />
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <DatePicker
              name="validFrom"
              label="Vrijedi od"
              value={formValues.validFrom ? new Date(formValues.validFrom) : null}
              onChange={handleValidFromChange}
              error={errors.validFrom}
              required
              width="full"
            />
          </div>

          <div className="flex-1">
            <DatePicker
              name="validTo"
              label="Vrijedi do"
              value={formValues.validTo ? new Date(formValues.validTo) : null}
              onChange={handleValidToChange}
              error={errors.validTo}
              required
              width="full"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(OverrideTermsStep);
